export default __webpack_public_path__ + "static/media/layout4.e8e78610.svg";